<template>
  <div class="content">
    <div class="title">提现审核</div>
    <el-tabs v-model="searchForm.state" @tab-click="handleClick">
      <el-tab-pane label="全部" name="-1"></el-tab-pane>
      <el-tab-pane label="待审核" name="0"></el-tab-pane>
      <el-tab-pane label="审核成功" name="10"></el-tab-pane>
      <el-tab-pane label="提交成功" name="30"></el-tab-pane>
      <el-tab-pane label="提交失败" name="40"></el-tab-pane>
      <el-tab-pane label="审核驳回" name="20"></el-tab-pane>
    </el-tabs>
    <Search :searchForm="searchForm" :searchList="searchList" :optionsType="optionsType"></Search>
    <!--    表格-->
    <el-table class="table" v-loading="searchForm.Loading" :data="tableList.list" border highlight-current-row
      style="width: 100%;" header-row-class-name="header">
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column v-for="(item, index) in tableData" :key="index" :prop="item.value" :label="item.text"
        align="center">
        <template slot-scope="{row}">
          <div v-if="item.value === 'nickName'">
            <img :src="row.headPic" class="header">{{ row[item.value] }}
          </div>
          <span
            v-if="item.value !== 'status' && item.value !== 'nickName' && item.value !== 'stateStr'">{{ row[item.value] }}</span>
          <el-tooltip class="item" effect="dark" :content="row[item.value]" placement="top">
            <div v-if="item.value == 'stateStr' && item.value !== 'nickName'" class="overText">{{ row[item.value] }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
          <div v-if="row.state === 0">
            <span class="add" @click="set(1, row)">打款</span>
            <span class="delete" @click="set(0, row)">驳回</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination v-if="tableList.total > 0" class="pagination" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="tableList.total">
    </el-pagination>
    <el-dialog :title="isRemit ? '打款' : '驳回'" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="dialog">
        <div class="dialog-text" v-if="isRemit">确认审核通过，进行打款？</div>
        <div class="dialog-text" v-else>确认审核驳回？</div>
        <textarea class="textarea" v-if="!isRemit" v-model="remark" placeholder="请输入驳回理由"></textarea>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogVisible = false">取消</div>
          <div class="button-success" @click="confirm()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
const MiniModel = new mini()
export default {
  name: "index",
  components: {
    Search
  },
  data() {
    return {
      searchForm: {
        withdrawNo: '',
        type: '',
        state: "-1",
        pageSize: 10,
        pageNo: 1,
        total: '',
        appKey: localStorage.getItem('appKeyMini'),
       
        Loading: true
      },
      dialogVisible: false,
      searchList: [
        {
          id: 'withdrawNo',
          text: '交易订单',
          placeholder: '请输入交易订单号',
          type: 'input'
        }, {
          id: 'withdrawType',
          text: '提现方式',
          placeholder: '请选择提现方式',
          type: 'select'
        }],
      // 表头
      tableData: [{
        text: '单号',
        value: 'withdrawNo',
      }, {
        text: '微信信息',
        value: 'nickName',
      }, 
      {
        text: '提现方式',
        value: 'withdrawTypeStr',
      }, {
        text: '真实姓名',
        value: 'name',
      }, {
        text: '收款账号 ',
        value: 'receipt',
      }, {
        text: '提现金额',
        value: 'actualAmount',
      }, {
        text: '提现时间',
        value: 'createTime',
      }, {
        text: '提现状态',
        value: 'stateStr',
      }],
      tableList: [],
      currentPage: 1,
      optionsType: [{
        label: '支付宝',
        value: 0
      }, {
        label: '银行卡',
        value: 1
      }],
      isRemit: 0, // 判断是打款还是驳回
      remark: '', // 备注
      id: '' // 当前ID
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleClick(e) {
      console.log(e.name)
      this.searchForm.state = e.name
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 获取列表
    getList() {
      MiniModel.withdrawalAudit(this.searchForm).then(res => {
        if (res.data.code == 200) {
          this.tableList = res.data.data
          this.searchForm.Loading = false
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    // 序号
    indexMethod(index) {
      index = (index + 1) + (this.searchForm.pageNo - 1) * this.searchForm.pageSize
      return index
    },
    // 操作
    set(index, row) {
      this.isRemit = index
      this.id = row.id
      this.dialogVisible = true
    },
    // 确定打款或者驳回
    confirm() {
      let param
      if (this.isRemit) {
        param = {
          userWithDrawAuditId: this.id,
          appKey: localStorage.getItem('appKeyMini'),
        }
        MiniModel.remitMini(param).then(res => {
          if (res.data.code == 200) {
            this.$message.success('打款成功')
          } else {
            this.$message.error(res.data.info || res.data.message)
          }
          this.dialogVisible = false
          this.getList()
        })
      } else {
        param = {
          id: this.id,
          remark: this.remark
        }
        MiniModel.remitBackMini(param).then(res => {
          if (res.data.code == 200) {
            this.$message.success('驳回成功')
          } else {
            this.$message.error(res.data.info)
          }
          this.dialogVisible = false
          this.getList()
        })
      }
    },
    // 导出
    exportButton() {
      MiniModel.exportMovieAudit(this.searchForm).then(res => {
        console.log(res)
        if (res.status == 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          console.log('blob', blob)
          let url = window.URL.createObjectURL(blob)
          console.log('url', url)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = window.URL.createObjectURL(blob)
          a.download = '提现审核列表导出_' + this.formatDate(new Date()) + '.xls'
          a.click()
          window.URL.revokeObjectURL(url)
        } else {
          // this.$Message.error(res.info || res.message)
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
  }
}
</script>

<style scoped lang="less">
.content {
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }
}

.table {
  margin-top: 30px;
}

.detail {
  display: flex;
  align-items: center;

  .detail-item {
    display: flex;
    margin-top: 20px;

    .item-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }

    .item-span {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 20px;
    }
  }
}

.dialog {
  padding: 20px 80px;

  .dialog-title {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }

  .dialog-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
  }

  .textarea {
    width: 100%;
    height: 82px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    margin-top: 10px;
  }

  .dialog-button {
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;

    .button-success {
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .button-cancel {
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.add {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF8622;
  line-height: 18px;
  cursor: pointer;
}

.delete {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 18px;
  cursor: pointer;
}

.header {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  margin-right: 4px;
}

.overText {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  cursor: pointer;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #EEEEEE;
}

/deep/.el-tabs__item.is-active {
  color: #FF8622 !important;
}

/deep/.el-tabs__active-bar {
  background-color: #FF8622 !important;
}

/deep/.el-tabs__item:hover {
  color: #FF8622 !important;
}

/deep/.el-table th,
.el-table tr {
  background-color: #FCFAF8;
}

/deep/.el-tabs__nav-wrap::after {
  height: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/audit/index.vue